// import React from 'react';

// export default function ContactModal({ onClose }) {
//   return (
//     <div style={overlay}>
//       <div style={modal}>
//         <button onClick={onClose} style={closeBtn}>✖</button>

//         <h3>SHREENATH FOODS</h3>

//         <p>
//           Shop No 6, 6-3-10/2, Balanagar,<br />
//           Behind Vilamtheater, Hyderabad,<br />
//           Telangana 500042, India
//         </p>

//         <p>📞 +91 9885019299</p>
//         <p>✉ onlinesales@shreenathfoods.com</p>

//         <iframe
//           src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2397.584439871128!2d78.4504243957508!3d17.463158175746702!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb90f2dcfd09a5%3A0xaa1cc50923de9aff!2sShreenath%20Foods!5e0!3m2!1sen!2sin!4v1767174932742!5m2!1sen!2sin"
//           width="100%"
//           height="300"
//           style={{ border: 0, marginTop: 15 }}
//           loading="lazy"
//           referrerPolicy="no-referrer-when-downgrade"
//         />
//       </div>
//     </div>
//   );
// }

// const footerStyle = {
//   display: 'flex',
//   justifyContent: 'space-between',
//   padding: 20,
//   alignItems: 'center',
//   flexWrap: 'wrap'
// };

// const contactBtn = {
//   padding: '10px 20px',
//   background: '#920e0e',
//   color: '#fff',
//   border: 'none',
//   cursor: 'pointer'
// };

// const overlay = {
//   position: 'fixed',
//   inset: 0,
//   background: 'rgba(0,0,0,0.6)',
//   display: 'flex',
//   justifyContent: 'center',
//   alignItems: 'center',
//   zIndex: 1000
// };

// const modal = {
//   background: '#fff',
//   width: '90%',
//   maxWidth: 600,
//   padding: 20,
//   position: 'relative'
// };

// const closeBtn = {
//   position: 'absolute',
//   right: 10,
//   top: 10,
//   border: 'none',
//   background: 'transparent',
//   fontSize: 18,
//   cursor: 'pointer'
// };


import React, { useState } from "react";
import axios from "axios";

export default function ContactModal({ onClose }) {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    type: "B2B",
    description: ""
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios.post("https://api.glocart.in/pages/api/api/enquiry", formData);
      alert("Enquiry submitted successfully!");
      setFormData({
        name: "",
        phone: "",
        email: "",
        type: "B2B",
        description: ""
      });
      onClose();
    } catch (error) {
      alert("Something went wrong!");
    }
  };

  return (
    <div style={overlay}>
      <div style={modal}>
        <button onClick={onClose} style={closeBtn}>✖</button>

        <div style={container}>
          {/* LEFT SIDE – ENQUIRY FORM */}
          <div style={left}>
            <h3>Enquiry Form</h3>

            <form onSubmit={handleSubmit} style={form}>
              <div style={field}>
                <label style={label}>Full Name</label>
                <input
                  type="text"
                  name="name"
                  placeholder="Enter your full name"
                  required
                  value={formData.name}
                  onChange={handleChange}
                  style={input}
                />
              </div>

              <div style={field}>
                <label style={label}>Mobile Number</label>
                <input
                  type="tel"
                  name="phone"
                  placeholder="Enter mobile number"
                  required
                  value={formData.phone}
                  onChange={handleChange}
                  style={input}
                />
              </div>

              <div style={field}>
                <label style={label}>Email Address</label>
                <input
                  type="email"
                  name="email"
                  placeholder="Enter email address"
                  required
                  value={formData.email}
                  onChange={handleChange}
                  style={input}
                />
              </div>

              <div style={field}>
                <label style={label}>Enquiry Type</label>
                <select
                  name="type"
                  value={formData.type}
                  onChange={handleChange}
                  style={select}
                >
                  <option value="B2B">B2B</option>
                  <option value="B2C">B2C</option>
                </select>
              </div>

              <div style={field}>
                <label style={label}>Description</label>
                <textarea
                  name="description"
                  placeholder="Write your enquiry here..."
                  rows="4"
                  value={formData.description}
                  onChange={handleChange}
                  style={textarea}
                />
              </div>

              <button type="submit" style={submitBtn}>
                Submit Enquiry
              </button>
            </form>

          </div>

          {/* RIGHT SIDE – YOUR CONTENT */}
          <div style={right}>
            <h3>GloCart</h3>
            <p>
              {/* Shop No 6, 6-3-10/2, Balanagar, */}
               1st Floor, 6-3-10/2, Balanagar, 
              <br />
              {/* Behind Vilamtheater, Hyderabad, */}
              Behind Vimal Theatre, Balanagar, 
              <br />
              {/* Telangana 500042, India */}
               Hyderabad, Medchal Malkajgiri, 500042
            </p>

            <p>📞 +91 9703933115</p>
            <p>✉ support@glocart.com
              {/* onlinesales@shreenathfoods.com */}
              

            </p>

            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2397.584439871128!2d78.4504243957508!3d17.463158175746702!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb90f2dcfd09a5%3A0xaa1cc50923de9aff!2sShreenath%20Foods!5e0!3m2!1sen!2sin!4v1767174932742!5m2!1sen!2sin"
              width="100%"
              height="250"
              style={{ border: 0, marginTop: 10 }}
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </div>
  );
}


const field = {
  display: "flex",
  flexDirection: "column",
  gap: 6
};

const label = {
  fontSize: 14,
  fontWeight: 600,
  color: "#333"
};

const input = {
  padding: "10px 12px",
  borderRadius: 6,
  border: "1px solid #ccc",
  fontSize: 14,
  outline: "none",
  transition: "0.3s",
};

const select = {
  padding: "10px 12px",
  borderRadius: 6,
  border: "1px solid #ccc",
  fontSize: 14,
  cursor: "pointer"
};

const textarea = {
  padding: "10px 12px",
  borderRadius: 6,
  border: "1px solid #ccc",
  fontSize: 14,
  resize: "none"
};

const submitBtn = {
  marginTop: 10,
  padding: "12px",
  background: "linear-gradient(135deg, #004887ff, #0357a0)",
  color: "#fff",
  border: "none",
  borderRadius: 6,
  fontSize: 15,
  fontWeight: 600,
  cursor: "pointer"
};

// thi left

const left = {
  flex: 1,
  background: "#ffffff",
  padding: 25,
  borderRadius: 10,
  boxShadow: "0 8px 20px rgba(0,0,0,0.08)"
};



const overlay = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.6)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1000
};

const modal = {
  background: "#fff",
  width: "90%",
  maxWidth: 900,
  padding: 20,
  position: "relative",
  borderRadius: 8
};

const container = {
  display: "flex",
  gap: 20,
  flexWrap: "wrap"
};

// const left = {
//   flex: 1,
//   background: "#f7f7f7",
//   padding: 20,
//   borderRadius: 6
// };

const right = {
  flex: 1,
  padding: 20
};

const form = {
  display: "flex",
  flexDirection: "column",
  gap: 12
};

const closeBtn = {
  position: "absolute",
  right: 10,
  top: 10,
  border: "none",
  background: "transparent",
  fontSize: 18,
  cursor: "pointer"
};
